import { useCallback } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { getAllCoupon } from "../../../actions/coupon";
import { useEffect } from "react";
import { createSearchParams } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import SweetAlert from "react-bootstrap-sweetalert";
import EditTabelDrawer from "../../../components/Edit-tabel-drawer/EditTabelDrawer";
import { Pagination } from "@mui/material";
import moment from "moment";
import AddNewCoupon from "./components/AddNewCoupon";

const NewCoupons = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Local State
  const [isMount, setisMount] = useState(false);
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });

  const [SelectItem, setSelectItem] = useState({});
  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });

  // Api calls for get Order
  const fetchData = useCallback(
    async (pageNo) => {
      const res = await dispatch(getAllCoupon(pageNo));
      setData(res?.coupon);
      setpagination({
        ...res?.pagination,
      });
      setloading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }
  }, [location.search]);

  useEffect(() => {

    var isSubscribe = true;
    if (isSubscribe) {
      var timer = setTimeout(() => {
        fetchData(pagination.currentPage);
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, Edit.open, isMount]);

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  //Delete Category
  const hanldeDeleteConfirm = async (id) => {
    setloading(true);
    const res = await dispatch();
    if (res) {
      setdeleteConfirm({
        open: false,
        id: null,
      });
      setisMount(!isMount);
      setloading(false);
    }
  };

  // hanlde add new Attributes
  const handleAddNew = () => {
    setEdit({
      open: true,
      edit: "AddNew",
      title: "Add New Copoun",
    });
    setSelectItem({});
  };
  // handle update attribute open
  const handleUpdate = (item) => {
    setEdit({
      open: true,
      edit: "update",
      title: "update Attributes",
    });
    setSelectItem({ ...item });
  };
  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div className=" d-flex  justify-content-end align-center">
            <CustomeTableBtn
              className={"mx-2 py-3 px-5"}
              color="secondary"
              width={"100px"}
              onClick={() => handleAddNew()}
            >
              Add New
            </CustomeTableBtn>
          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Coupon List"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="dashboard-pages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Title</th>
                      <th>Price (%)</th>
                      <th>Coupon Code</th>
                      <th>Valid From</th>
                      <th>Valid To</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.length ? (
                      <>
                        {Data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td className="order-item-number">{i + 1}</td>
                            <td>{item.title}</td>
                            <td>{item.pricePercentage}%</td>
                            <td>{item.code}</td>
                            <td>{moment(item.from).format("l")}</td>
                            <td>{moment(item.to).format("l")}</td>
                            <td>{moment(item.createdAt).format("l")}</td>

                            <td>
                              <CustomeTableBtn
                                color="secondary"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() => handleUpdate(item)}
                              >
                                Edit
                              </CustomeTableBtn>

                              <CustomeTableBtn
                                color="danger"
                                width={"100px"}
                                onClick={() =>
                                  setdeleteConfirm({
                                    open: true,
                                    id: item?._id,
                                  })
                                }
                              >
                                Delete
                              </CustomeTableBtn>

                              {deleteConfirm.open && (
                                <SweetAlert
                                  warning
                                  showCancel
                                  confirmBtnText="Yes, delete it!"
                                  confirmBtnBsStyle="danger"
                                  title="Are you sure?"
                                  onConfirm={(e) => {
                                    hanldeDeleteConfirm(deleteConfirm.id);
                                  }}
                                  onCancel={() =>
                                    setdeleteConfirm({
                                      open: false,
                                      id: null,
                                    })
                                  }
                                  focusCancelBtn
                                >
                                  Are you sure you want to delete?
                                </SweetAlert>
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            {" "}
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
                <EditTabelDrawer
                  Edit={Edit}
                  setEdit={setEdit}
                  shippingId={SelectItem?.name}
                >
                  {Edit.edit === "AddNew" && (
                    <AddNewCoupon
                      isMount={isMount}
                      setisMount={setisMount}
                      setEdit={setEdit}
                    />
                  )}
                  {Edit.edit === "update" && (
                    // this also use for edit
                    <AddNewCoupon
                      SelectItem={SelectItem}
                      isMount={isMount}
                      setisMount={setisMount}
                      setEdit={setEdit}
                    />
                  )}

                  <hr className=" mb-0" />
                </EditTabelDrawer>
                <div className="d-flex justify-content-center align-center p-2">
                  <div className=" mx-auto">
                    <Pagination
                      count={pagination.totalPages}
                      page={pagination.currentPage}
                      onChange={handleChange}
                    />
                  </div>

                  <span
                    className=" font-weight-bold"
                    style={{ color: "#9f9f9f" }}
                  >
                    {Data?.length} of {pagination?.count} Items
                  </span>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default NewCoupons;
